export { Faq1 } from "./Faq1"; 
export { Accordion1 } from "./Accordion1"; 